// extracted by mini-css-extract-plugin
export default {"socialL1":"SocialL1_socialL1__c9srS","smallPiegraph":"SocialL1_smallPiegraph__+z9ir"};